export const getUsers = "get/Users"
export const getStories = "get/AllStories"